module.exports = __webpack_public_path__ + "img/cosmetology-careers.30c5f8fe.jpg";